import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PencilToPaper from './pencil-to-paper-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PencilToPaper {...validProps} />;
}

SvgComponent.iconName = 'pencilToPaper';

export const PencilToPaperIcon = svgIconWrapper(SvgComponent);
